module.exports = __webpack_public_path__ + "media/images/notify-icon-88166d542d298a77a643e64d034bb383.svg";